export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-[#0a0a0c]">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/916c03a80191d242cb969952aac0a46a.jpg"
          alt="Professional towing and recovery operations"
          className="w-full h-full object-cover object-center"
        />
        {/* Layered overlays for depth */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0c]/90 via-[#0a0a0c]/60 to-[#0a0a0c]/30"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0c]/80 via-transparent to-[#0a0a0c]/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-20">
        <div className="max-w-3xl">
          {/* Eyebrow */}
          <div className="flex items-center gap-3 mb-8">
            <div className="w-8 h-px bg-[#D4AF37]"></div>
            <span className="text-[#D4AF37] text-xs tracking-[0.3em] uppercase font-medium">
              Riverside, CA &bull; Est. 1991
            </span>
          </div>

          {/* H1 */}
          <h1
            className="text-white font-black leading-[1.05] mb-6"
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontSize: "clamp(2.8rem, 6vw, 5rem)",
            }}
          >
            Inland Empire&apos;s
            <br />
            <span className="text-[#D4AF37]">Premier Recovery</span>
            <br />
            &amp; Transport Authority
          </h1>

          {/* Subheading */}
          <p className="text-[#b8b8b8] text-lg md:text-xl leading-relaxed mb-10 max-w-xl">
            Professional towing, secure transport, and rapid recovery for institutions, fleets, municipalities, and private clients across Southern California — 24 hours a day, every day.
          </p>

          {/* CTA Cluster */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <a
              href="tel:9516822003"
              className="bg-[#D4AF37] text-black font-bold text-base px-8 py-4 rounded-sm tracking-wider uppercase flex items-center justify-center gap-2 hover:bg-[#c49f27] transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill"></i>
              </div>
              Dispatch Now
            </a>
            <a
              href="#services"
              className="border border-white/40 text-white font-semibold text-base px-8 py-4 rounded-sm tracking-wider uppercase flex items-center justify-center gap-2 hover:border-white hover:bg-white/5 transition-all whitespace-nowrap cursor-pointer"
            >
              View Services
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          </div>

          {/* Trust cue */}
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <span className="flex items-center gap-2 text-[#b8b8b8] text-sm">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shield-check-line text-[#D4AF37]"></i>
              </div>
              Family-Owned Since 1991
            </span>
            <span className="text-[#3a3a3c]">|</span>
            <span className="flex items-center gap-2 text-[#b8b8b8] text-sm">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-government-line text-[#D4AF37]"></i>
              </div>
              Municipal Contract Provider
            </span>
            <span className="text-[#3a3a3c]">|</span>
            <span className="flex items-center gap-2 text-[#b8b8b8] text-sm">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-time-line text-[#D4AF37]"></i>
              </div>
              24/7 Dispatch
            </span>
          </div>
        </div>

        {/* Floating availability card */}
        <div className="hidden lg:block absolute right-8 top-1/2 -translate-y-1/2 bg-[#1a1a1c]/80 backdrop-blur-md border border-[#2a2a2c] rounded-lg p-6 w-64">
          <div className="flex items-center gap-2 mb-4">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
            </span>
            <span className="text-white font-semibold text-sm">Available Now</span>
          </div>
          <p className="text-[#b8b8b8] text-xs leading-relaxed mb-4">
            Dispatchers standing by for immediate response across Riverside and the Inland Empire.
          </p>
          <div className="border-t border-[#2a2a2c] pt-4">
            <p className="text-[#D4AF37] font-bold text-lg">(951) 682-2003</p>
            <p className="text-[#b8b8b8] text-xs mt-1">Riverside &bull; Moreno Valley &bull; Colton</p>
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0a0a0c] to-transparent"></div>
    </section>
  );
}
